import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'backlog.flags.card-move-disabled.title',
		defaultMessage: 'Issues can’t be manually ranked',
		description: 'Flag title. Informs a user that manual ranking is disabled.',
	},
	description: {
		id: 'backlog.flags.card-move-disabled.description',
		defaultMessage:
			'The board’s filter query isn’t sorted by rank. To rank issues manually on your board and backlog, sort issues by ascending rank.',
		description: 'Flag description. Informs a user why ranking is disabled',
	},
	contactAdmin: {
		id: 'backlog.flags.card-move-disabled.contact-admin',
		defaultMessage: 'Contact your admin to adjust the board filter.',
		description:
			'Flag description. Informs an end user to contact their admin as a means to resolve the warning.',
	},
	showJqlFilterForBoard: {
		id: 'backlog.flags.card-move-disabled.show-jql-filter-for-board',
		defaultMessage: 'Manage board filter',
		description: 'Filter configuration caption',
	},
	learnMore: {
		id: 'backlog.flags.card-move-disabled.learn-more',
		defaultMessage: 'Learn more',
		description: 'Links to enable ranking support doc',
	},
	titleIssueTermRefresh: {
		id: 'backlog.flags.card-move-disabled.title-issue-term-refresh',
		defaultMessage: 'Issues can’t be manually ranked',
		description: 'Flag title. Informs a user that manual ranking is disabled.',
	},
	descriptionIssueTermRefresh: {
		id: 'backlog.flags.card-move-disabled.description-issue-term-refresh',
		defaultMessage:
			'The board’s filter query isn’t sorted by rank. To rank issues manually on your board and backlog, sort issues by ascending rank.',
		description: 'Flag description. Informs a user why ranking is disabled',
	},
});
